import { BRAND } from "../config/content";

export const Marquee = ({ dark = false }) => {
  const items = Array(6).fill(BRAND.marquee);
  return (
    <div
      data-testid="editorial-marquee"
      className={`overflow-hidden border-y ${dark ? "border-ivory/10 bg-ink" : "border-line bg-ivory"}`}
    >
      <div className="marquee-track flex w-max py-3">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {items.map((t, i) => (
              <span
                key={i}
                className={`font-serif italic text-sm tracking-wide whitespace-nowrap pr-2 ${
                  dark ? "text-ivory/50" : "text-muted2"
                }`}
              >
                {t}
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
